<template>
  <div class="store-manage-container">
    <div class="header">
      <el-button type="primary" :disabled="!!storeData" @click="addStore">
        新增
      </el-button>
    </div>
    <div class="store-table">
      <el-table
        :data="storeData ? [storeData] : []"
        style="width: 100%"
        border
        stripe
        v-loading="loading"
        element-loading-text="加载门店信息中..."
        empty-text="暂无门店信息"
      >
        <el-table-column prop="storeName" label="门店名称" />
        <el-table-column label="门店logo" width="100">
          <template #default="{ row }">
            <el-image
              v-if="row.storeLogo"
              :src="row.storeLogo"
              fit="cover"
              :preview-src-list="[row.storeLogo]"
              style="width: 60px; height: 60px; border-radius: 4px"
            >
              <template #error>
                <div class="image-slot">无logo</div>
              </template>
            </el-image>
            <div v-else class="no-logo">无logo</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="contactNumbers"
          label="门店联系电话"
          width="130"
        />
        <el-table-column label="营业执照" width="100">
          <template #default="{ row }">
            <el-image
              v-if="row.businessLicense"
              :src="row.businessLicense"
              fit="cover"
              :preview-src-list="[row.businessLicense]"
              style="width: 60px; height: 60px; border-radius: 4px"
            >
              <template #error>未上传</template>
            </el-image>
            <div v-else>未上传</div>
          </template>
        </el-table-column>
        <el-table-column label="门店地址" min-width="200">
          <template #default="{ row }">
            <div v-if="row.address">{{ row.address }}</div>
            <div v-else>未设置地址</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template #default="{ row }">
            {{ formatDateTime(row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template #default="{ row }">
            <div class="action-buttons">
              <el-button type="text" @click="editStore(row)">编辑</el-button>
              <el-button
                type="text"
                @click="deleteStore(row)"
                style="color: #f56c6c"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreManage",
  data() {
    return {
      loading: true,
      storeData: null,
    };
  },
  mounted() {
    this.fetchStoreData();
  },
  methods: {
    async fetchStoreData() {
      try {
        this.loading = true;
        const token = localStorage.getItem("token");
        if (!token) {
          this.$message.warning("请先登录");
          this.$router.push("/MerchantLogin");
          return;
        }
        const response = await this.$http.get("/api/storeinfo", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.code === 0) {
          const store = response.data.data;
          // 修正：去掉图片路径拼接的 /api 前缀，直接使用后端返回的原始路径
          this.storeData = {
            ...store,
            // 后端返回的 storeLogo/businessLicense 已在上传时添加过 /api，无需重复添加
            storeLogo: store.storeLogo || "",
            businessLicense: store.businessLicense || "",
            otherCertificates: store.otherCertificates || [],
          };
        } else {
          this.storeData = null;
          this.$message.error("获取门店信息失败");
        }
      } catch (error) {
        this.storeData = null;
        if (error.response?.status === 401) {
          this.$message.error("登录已过期，请重新登录");
          localStorage.removeItem("token");
          this.$router.push("/MerchantLogin");
        } else {
          this.$message.error("获取门店信息失败，请稍后重试");
        }
      } finally {
        this.loading = false;
      }
    },
    addStore() {
      const routeData = this.$router.resolve({ name: "AddStore" });
      window.open(routeData.href, "_blank");
    },
    editStore(store) {
      const routeData = this.$router.resolve({
        name: "EditStore",
        params: { storeId: store._id },
      });
      window.open(routeData.href, "_blank");
    },
    async deleteStore(store) {
      try {
        await this.$confirm("确认删除此门店信息吗?", "提示");
        const response = await this.$http.delete(
          `/api/deletestore/${store._id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (response.data.code === 0) {
          this.$message.success("门店删除成功");
          this.fetchStoreData();
        } else {
          throw new Error(response.data.message || "删除失败");
        }
      } catch (error) {
        if (error !== "cancel") this.$message.error("删除失败，请重试");
      }
    },
    formatDateTime(isoString) {
      if (!isoString) return "无";
      const date = new Date(isoString);
      const localTime = new Date(date.getTime() + 8 * 60 * 60 * 1000);
      return localTime.toISOString().replace("T", " ").substring(0, 19);
    },
  },
};
</script>

<style scoped>
.store-manage-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 64px); /* 修复：空格缺失导致高度计算错误 */
}
.header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.store-table {
  background-color: #fff;
  border-radius: 4px;
  padding: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.no-logo,
.image-slot {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  color: #999;
}
.action-buttons {
  display: flex;
  justify-content: space-around;
}
</style>